import * as React from 'react';
import { useHistory } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GroupsIcon from '@mui/icons-material/Groups';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ArticleIcon from '@mui/icons-material/Article';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SettingsIcon from '@mui/icons-material/Settings';

import { useAppSelector } from '../../hooks';

export function MainListItems(props: any) {

  const history = useHistory()

  const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

  return (
    <React.Fragment>
      <ListItemButton onClick={() => history.push('/admin/dashboard')}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      <ListItemButton onClick={() => history.push('/admin/campaigns')}>
        <ListItemIcon>
          <CampaignIcon />
        </ListItemIcon>
        <ListItemText primary="Campaigns" />
      </ListItemButton>
      <ListItemButton onClick={() => history.push('/admin/ambassadors')}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary={selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassadors'} />
      </ListItemButton>
      <ListItemButton onClick={() => history.push('/admin/donations')}>
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Donations" />
      </ListItemButton>
      <ListItemButton onClick={() => history.push('/admin/integrations')}>
        <ListItemIcon>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Integrations" />
      </ListItemButton>
      <ListItemButton onClick={() => history.push('/admin/settings')}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Settings" />
      </ListItemButton>
    </React.Fragment>
  )
};

export function SecondaryListItems(props: any) {

  const history = useHistory()

  return (
    <React.Fragment>
      <ListSubheader component="div" inset>
        Organization
      </ListSubheader>
      <ListItemButton onClick={() => history.push('/admin/subscription')}>
        <ListItemIcon>
          <CreditCardIcon />
        </ListItemIcon>
        <ListItemText primary="Subscription" />
      </ListItemButton>
      <ListItemButton disabled>
        <ListItemIcon>
          <GroupsIcon />
        </ListItemIcon>
        <ListItemText primary="Team" />
      </ListItemButton>
      <ListItemButton onClick={() => {
        window.open('https://docs.latent.flourishos.com', '_blank')
      }}>
        <ListItemIcon>
          <ArticleIcon />
        </ListItemIcon>
        <ListItemText primary="Documentation" />
        <OpenInNewIcon fontSize='small' />
      </ListItemButton>
      <ListItemButton onClick={() => {
        // @ts-ignore
        window.Tawk_API.maximize()
        // @ts-ignore
        window.DevRevSupportSdk.maximize()
      }}>
        <ListItemIcon>
          <SupportAgentIcon />
        </ListItemIcon>
        <ListItemText primary="Support" />
      </ListItemButton>
    </React.Fragment>
  )
};